import { StaticImageData } from 'next/image'

export enum ExpertiseItemId {
  WebDevelopment = 'Web development',
  AppDevelopment = 'App development',
  UxUiDesign = 'UX/UI design',
  AiTransformation = 'AI transformation',
  ItConsulting = 'IT Consulting',
  AuditCompliance = 'Audit & Compliance',
}

export type ExpertiseItem = {
  description: string
  id: ExpertiseItemId
  illustration: StaticImageData
  title: string
}
